const copyArray = function(array) {
    const length = array.length;
    const result = new Array(length);
    for (let i = 0; i < length; i++) {
        result[i] = array[i];
    }
    return result;
};

const escapeRegExp = function(string) {
    let escaped = "";
    const padding = "0000";

    for (let i = 0, len = string.length; i < len; i++) {
        const code = string.charCodeAt(i).toString(16);
        escaped += "\\u" + padding.slice(0, 4 - code.length) + code;
    }

    return escaped;
};

const Parser = function(obj) {
    if (obj) {
        Object.keys(obj).forEach(function(key) {
            this[key] = obj[key];
        }, this);
    }
};

Parser.prototype = {
    match: function(string) {
        return {
            "match": null,
            "tail": string
        };
    },

    parse: function(string, _default) {
        const parsed = this.match(string);
        if (parsed && !parsed.tail) {
            return parsed.match;
        }
        return _default === void 0 ? null : _default;
    },

    transform: function(func, context) {
        const _this = this;

        return new Parser({
            match: function(string) {
                const result = _this.match(string);
                if (!result) {
                    return null;
                }
                return func.call(context, result);
            }
        });
    },

    pick: function() {
        const args = copyArray(arguments);

        return this.transform(function(result) {
            if (args.length === 0) {
                return null;
            }
            if (args.length === 1) {
                return {
                    "match": result.match[args[0]],
                    "tail": result.tail
                };
            }

            const results = [];
            for (let i = 0, len = args.length; i < len; i++) {
                results.push(result.match[args[i]]);
            }
            return {
                "match": results,
                "tail": result.tail
            };
        });
    },

    map: function(func, context) {
        return this.transform(function(result) {
            return {
                "match": func.call(context, result.match),
                "tail": result.tail
            };
        });
    }
};

const word = function(exp, ignoreCase) {
    if (typeof exp === "string") {
        exp = new RegExp("^" + escapeRegExp(exp), ignoreCase ? "i" : "");
    } else {
        ignoreCase = exp.ignoreCase;
        exp = new RegExp("^(?:" + exp.source + ")", ignoreCase ? "i" : "");
    }

    return new Parser({
        match: function(string) {
            const match = string.match(exp);
            if (!match) {
                return null;
            }

            return {
                "match": match,
                "tail": string.slice(match[0].length, string.length)
            };
        }
    });
};

const sequence = function() {
    const args = copyArray(arguments);

    return new Parser({
        match: function(string) {
            const results = [];
            for (let i = 0, len = args.length; i < len; i++) {
                const result = args[i].match(string);
                if (!result) {
                    return null;
                }

                results.push(result.match);
                string = result.tail;
            }

            return {
                "match": results,
                "tail": string
            };
        }
    });
};

const epsilon = function() {
    const value = arguments.length === 0 ? null : arguments[0];
    return new Parser({
        match: function(string) {
            return {
                "match": value,
                "tail": string
            };
        }
    });
};

const union = function() {
    const args = copyArray(arguments);

    return new Parser({
        match: function(string) {
            for (let i = 0, len = args.length; i < len; i++) {
                const result = args[i].match(string);
                if (result !== null) {
                    return result;
                }
            }
            return null;
        }
    });
};

const repeat = function(exp, _min, _max) {
    const min = _min === void 0 ? 0 : _min;
    const max = _max === void 0 ? Infinity : _max;

    return new Parser({
        match: function(_string) {
            let string = _string;
            const matches = [];

            for (let i = 0; i < max; i++) {
                const result = exp.match(string);
                if (result === null) {
                    break;
                }
                matches.push(result.match);
                string = result.tail;
            }

            if (matches.length < min) {
                return null;
            }
            return {
                "match": matches,
                "tail": string
            };
        }
    });
};

const maybe = function(exp) {
    return union(exp, epsilon(null));
};

const proxy = function(parser) {
    return new Parser({
        parser: parser || new Parser(),

        set: function(parser) {
            this.parser = parser;
        },

        match: function(string) {
            return this.parser.match(string);
        }
    });
};

const delimited = function(delimiter, escapeChar) {
    const d = escapeRegExp(delimiter);
    const e = escapeRegExp(arguments.length >= 2 ? escapeChar : "\\");
    const exp = d + "((?:" + e + ".|[^" + e + d + "])*)" + d;
    return word(new RegExp(exp)).pick(1);
};

export default {
    "Parser": Parser,
    "epsilon": epsilon,
    "word": word,
    "sequence": sequence,
    "union": union,
    "repeat": repeat,
    "maybe": maybe,
    "proxy": proxy,
    "delimited": delimited,
    "escapeRegExp": escapeRegExp
};

export {
    Parser,
    epsilon,
    word,
    sequence,
    union,
    repeat,
    maybe,
    proxy,
    delimited,
    escapeRegExp
};



// WEBPACK FOOTER //
// ./src/abusesa-js/parser.js